import { programStatus, type ProgramStatus } from '../lib/programStatus';
import type { Program } from '../api/useGetPrograms';

const statusClass: Record<ProgramStatus, string> = {
  Live: 'bg-green-100 text-green-700',
  Upcoming: 'bg-blue-100 text-blue-700',
  Past: 'bg-gray-100 text-gray-600',
  Expired: 'bg-red-100 text-red-700',
};

export const ProgramStatusBadge = ({ program }: { program: Pick<Program, 'active' | 'starts_at' | 'ends_at'> }) => {
  const status = programStatus(program);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${statusClass[status]}`}>
      {status}
    </span>
  );
};
